import { render } from "./ChatInput.vue?vue&type=template&id=7b809e90&scoped=true"
import script from "./ChatInput.vue?vue&type=script&lang=js"
export * from "./ChatInput.vue?vue&type=script&lang=js"

import "./ChatInput.vue?vue&type=style&index=0&id=7b809e90&scoped=true&lang=css"

import exportComponent from "/Users/jluan/code/whatgpt/web-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b809e90"]])

export default __exports__